import happyPackageApi from '@/api/happyPackage/happyPackageApi.js';
import breadCrumb from '@/store/breadCrumb';
import authorizeApi from '@/api/authorize/authorizeApi';
import store from '@/store/store';

export default {
	name: 'happy-package-group',
	mixins: [],
	extends: {},
	components: {},
	props: [ 'selectedKey' ],
	data() {
		return {
			happyPackageGroup: {},
		};
	},
	computed: {
		id() {
			return this.happyPackageGroup.id;
		},
		key() {
			return this.happyPackageGroup.key;
		},
		title() {
			return this.happyPackageGroup.title;
		},
		happyPackages() {
			return this.happyPackageGroup.happyPackages;
		}
	},
	watch: {
		selectedKey() {
			this.init();
		}
	},
	created() {},
	mounted() {
		$.magnificPopup.close(); // 關閉可能出現的快速登入視窗
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init() {
			let resp = await happyPackageApi.getHappyPackageGroup(this.selectedKey);
			if (resp) {
				if (resp.happyPackageGroup) {
					this.happyPackageGroup = resp.happyPackageGroup;
					this.$store.state.breadCrumb = [breadCrumb.SERVICE, this.title];
					this.setBidHistoryPage();
				} else {
					// not found
					this.$router.push({name: 'gt-error-404'});
				}
			}
		},
		setBidHistoryPage() {
			sessionStorage.setItem('bidHistoryPage', `/Service/#/HappyPackageGroup/${this.key}`);
		},
		redirectTo(happyPackage) {
			if (!store.state.profile.name || !sessionStorage.getItem('cas')) {
				// 未登入
				this.$router.push({ name: 'bid-login', query: { bidType: 'happyPackageGroup', returnUrl: `%2FService%2F%23%2FHappyPackage%2F${happyPackage.key}` } });
				//window.location.href = `/Service/#/bid/login?bidType=happyPackageGroup&bidCode=${happyPackage.id}&returnUrl=%2FService%2F%23%2FHappyPackage%2F${happyPackage.key}`;
			} else {
				// 已登入
				this.$router.push({ path: `/HappyPackage/${happyPackage.key}` });
				//window.location.href = `/Service/#/happyPackage/${happyPackage.key}`
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/happyPackageGroup/happyPackageGroup.js